import GameModel from "../../../core/src/model/GameModel";
import Utils from "../../../core/src/utils/Utils";
import GetGameRequest from "./GetGameRequest";

export default class GetGameParametersRequest extends GetGameRequest {
  get requestData(): any {
    let userId = GameModel?.playerConfig?.userId || undefined;
    return {
      "action": "getGameParameters",
      "gameId": GameModel.apiConfig.gameId,
      "userId": userId,
      "authToken": GameModel.authToken,
      "currency": GameModel.currency,
      "casino": GameModel.casino,
      "sessionId": GameModel.sessionID,
      "machineId": 0,
      "tutorialPoint": 0,
      'serverVersion': GameModel.apiConfig.serverVersion,
      'gameVersion': Utils.isNullOrWhiteSpace(GameModel.apiConfig.gameVersion) ? GameModel?.gameVersion : GameModel.apiConfig.gameVersion,
      'deviceInfo': Utils.getDeviceInfo(),
      'freeSpinSymbol': GameModel.freeSpinSymbol,
      "playerToken": GameModel.playerToken
    }
  }

}